module.exports = __webpack_public_path__ + "img/minbg.0a9c93f0.jpg";